import React from 'react';
import PropTypes from 'prop-types';
import IconCollection from '../../IconCollection/IconCollection';

const EventGroupCheckboxes = (props) => { // Added selectAll prop
  const {
    filteredData,
    selectedGroups,
    handleGroupCheckboxChange,
    toggleSelectAll,
    unselectAll,
    selectAll,
    searchText,
    setSearchText
  } = props;
  return (
    <div>
      <div className="max-w-full md:max-w-[432px] w-full h-12 mt-6 border-[#ABABAB] border-[1px] rounded py-3 px-4 flex items-center gap-[10px]">
        <input
          className="border-none outline-none placeholder:text-[#636363] placeholder:text-sm placeholder:font-medium text-sm font-medium flex-1"
          placeholder="Event Group Name"
          type="text"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <IconCollection name="search" />
      </div>
      <div className="">
        {selectedGroups.length > 0 && (
          <button className="text-[#A46E40] text-base font-medium pt-4" onClick={unselectAll}>
            Clear all selections
          </button>
        )}
      </div>
      <div id="checkBoxes" className="flex pt-4 flex-col gap-3 max-h-[324px] overflow-y-auto custom-scrollbar mr-[6px]">
       <button onClick={() => selectAll()} className="max-w-full md:max-w-[432px] w-full h-12 rounded-md border-none bg-[#F2F2F2] flex justify-start items-center p-3 gap-3 cursor-pointer">
          <input
            type="checkbox"
            className="max-w-8 min-w-8 h-8 border-[1px] border-[#ABABAB] rounded bg-transparent"
            id="selectAll"
            checked={selectedGroups.length > 0 && filteredData.length && selectedGroups.length === filteredData.length}
            onChange={toggleSelectAll}
          />
          <label className="text-xl text-[#4A4A4A] font-bebas" htmlFor="selectAll">
            All
          </label>
        </button>
        {filteredData.map((group, i) => (
          <div className="max-w-full md:max-w-[432px] w-full h-12 rounded-md border-none bg-[#F2F2F2] flex justify-start items-center p-3 gap-3 cursor-pointer" key={i}>
            <input
              type="checkbox"
              className="max-w-8 min-w-8  h-8 border-[1px] border-[#ABABAB] rounded bg-transparent"
              id={i}
              checked={selectedGroups.includes(group.event_group_name)}
              onChange={(e) => handleGroupCheckboxChange(e.target.checked, group.event_group_name)}
            />
            <label className="text-xl text-[#4A4A4A] font-bebas" htmlFor={group.id}>
              <span>GC{group.event_group_id} </span>&nbsp;  {group.event_group_name}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

EventGroupCheckboxes.propTypes = {
  filteredData: PropTypes.array.isRequired,
  selectedGroups: PropTypes.array.isRequired,
  handleGroupCheckboxChange: PropTypes.func.isRequired,
  toggleSelectAll: PropTypes.func.isRequired,
  unselectAll: PropTypes.func.isRequired,
  selectAll: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  setSearchText: PropTypes.func.isRequired,
};

export default EventGroupCheckboxes;